import React from 'react';
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";
import TypedLink from '../TypedLink/TypedLink.js';
import './ProductCartItem.css';

class ProductCartItem extends React.Component {

  max_quantity = 10;

  constructor(props) {
    super(props);

    this.state = {
      product: props.product ? props.product : {},
    };

    this.select_quantity = props.select_quantity ? props.select_quantity : false;
    this.on_change_product = props.on_change_product ? props.on_change_product : () => {};
  }

  handle_quantity_change(event) {

    event.preventDefault();

    const product = {...this.state.product};
    product.pc = parseInt(event.target.value);

    
    this.on_change_product(product,event);
    
  }

  render_image(product)
  {
    if(product?.product_image[0]?.thumb_list_new_?.filename)
    {
      return <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+product.product_image[0].thumb_list_new_.filename}/>
    }
  }

  on_product_click(e) {
    window.modals?.ShoppingCartRef?.current.hide();
    window.modals?.ProfileMenuRef?.current.hide();
    window.modals?.MyOrdersRef?.current.hide();
    window.modals?.MyOrdersRef_2?.current.hide();
  }

  render() {

    const product = this.state.product;

    if (!!product.id)
    {
      return ( 
        <div key={product.id} className="product_cart_item"> 

          <div className="product_image">
          {product.url.length && parseInt(product.active) ? <TypedLink onClick={(e)=> this.on_product_click(e)} link={{type: 'product', url: product.url}}>
              {this.render_image(product)}
            </TypedLink> : this.render_image(product)}
          </div>

          <div className="product_data">
            <div className="name">{product.url.length && parseInt(product.active) ? <TypedLink onClick={()=>{window.modals.ShoppingCartRef.current.hide()}} link={{type: 'product', url: product.url}}><b>{product.product}</b></TypedLink> : <b>{product.product}</b>}</div>

            <div className="price">
              <label>{i18n.t('shoppingCartGrossPrice')}:</label>
              <p>
                {!!product.sale ? <b className='stroked'>{product.price_original_gross}</b> : ''}
                <b className={!!product.sale ? "sale" : ''}>{product.price_gross}</b>
              </p>
            </div>

            {product.item_attributes ? 
            <div className="attributes">
              {parseInt(product.ugyfelkartya_product) === 1 ? <label>{i18n.t('shoppingCartAmount')}:</label> : <label>{i18n.t('shoppingCartColor')} / {i18n.t('shoppingCartSize')}:</label>}
              <p>{product.item_attributes}</p>
            </div>
            : ''}
            
            <div className="quantity">
              <label>{i18n.t('shoppingCartQuantity')}:</label>
              {!!this.select_quantity ? 
                <div>
                  <span className="select">
                    <select defaultValue={parseInt(product.pc)} onChange={(e) => this.handle_quantity_change(e)}>
                      <option value="0">{i18n.t('productCartItemRemove')}</option>
                      {Array(this.max_quantity).fill('').map((value, index) => <option key={index+1} value={index+1}>{index+1}</option>)} 
                    </select>
                    <ReactSVG src="assets/images/arrow_down.svg" />
                  </span>
                </div>
              : <p>{product.quantity}</p>}
            </div>

          </div>

        </div>
      );
    }
    else {
      return '';
    }
  }
};

export default ProductCartItem;

